import {pageInfo, initUpdate} from "../api";
import {getWorkFlowLog, shipStatus} from '../../../../../api'

const coalShip = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    shipStatusObj: null,
    shipWorkFlowLogObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    SHIP_STATUS_DATA(state, data){
      state.shipStatusObj = data.obj;
    },
    GET_SHIP_WORK_FLOW_LOG(state, data){
      state.shipWorkFlowLogObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //下拉框节点状态
    async shipStatus({ commit }, obj) {
      let resp = await shipStatus(obj);
      commit('SHIP_STATUS_DATA', resp);
    },
    //运作单流程详情
    async getShipWorkFlowLog({ commit }, obj) {
      let resp = await getWorkFlowLog(obj);
      commit('GET_SHIP_WORK_FLOW_LOG', resp);
    },
  }
}
export default coalShip



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalShip/store/coalShip.store.js